var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3C8.25 2.58579 8.58579 2.25 9 2.25H19C19.4142 2.25 19.75 2.58579 19.75 3V15C19.75 15.4142 19.4142 15.75 19 15.75H17V14.25H18.25V3.75H9.75V7H8.25V3ZM5 8.25C4.58579 8.25 4.25 8.58579 4.25 9V21C4.25 21.4142 4.58579 21.75 5 21.75H15C15.4142 21.75 15.75 21.4142 15.75 21V9C15.75 8.58579 15.4142 8.25 15 8.25H5ZM5.75 20.25V9.75H14.25V20.25H5.75Z",
    fill: "#454545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlack);
export default __webpack_public_path__ + "static/media/copy-icon-black.610c7ce438e19117128a751af5b98bc5.svg";
export { ForwardRef as ReactComponent };